import { useMemo, useState } from 'react';
import { DevicesContext } from './DevicesContext';
import { Device } from '../../models/Devices';

const DevicesProvider = ({ children }: { children: React.ReactNode }) => {
    const [devices, setDevices] = useState<Device[]>([]);
    const [device, setDevice] = useState<Device>({
        productId: '',
        name: '',
        offeringId: '',
        description: '',
        price: 0,
        startDate: '',
        endDate: '',
        months: 0,
        imageId: '',
        deviceType: '',
    });

    const resetDevice = () => {
        setDevice({
            productId: '',
            name: '',
            offeringId: '',
            description: '',
            price: 0,
            startDate: '',
            endDate: '',
            months: 0,
            imageId: '',
            deviceType: '',
        });
    };

    const value = useMemo(
        () => ({
            devices,
            device,
            setDevices,
            setDevice,
            resetDevice,
        }),
        [devices, device],
    );

    return <DevicesContext.Provider value={value}>{children}</DevicesContext.Provider>;
};

export default DevicesProvider;
